import { ref, onUnmounted, computed } from 'vue'
import {
  featureAccess,
  type ResolvedAccess,
  AccessType,
} from '@onxmaps/feature-access'

/**
 * *(AI-generated)*
 * Composable that reactively resolves and tracks feature access for the given feature key.
 */
export const useHasAccess = (featureKey: string) => {
  const accessRef = ref<ResolvedAccess>()

  const hasAccess = computed<boolean>(
    () => accessRef.value?.type === AccessType.HAS_ACCESS
  )

  const setHasAccess = (accessType: ResolvedAccess) =>
    (accessRef.value = accessType)

  // Stores the featureAccess check promise so callers can await it when needed
  const accessPromise: Promise<ResolvedAccess> = featureAccess
    .hasAccess(featureKey)
    .then(setHasAccess)

  const listenerRegistration = featureAccess.registerListener(
    featureKey,
    setHasAccess
  )

  onUnmounted(async () => {
    await listenerRegistration
    featureAccess.removeListener(featureKey, setHasAccess)
  })

  return {
    accessRef,
    hasAccess,
    accessPromise,
  }
}
